import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { NavigationMenuMobile } from '../'
import './MobileNav.sass'


class MobileNav extends Component {
  state = {
    isExpanded: false
  }

  constructor() {
    super()
    this._toggleExpand = this.toggleExpand.bind(this)
    this._closeMenu = this.closeMenu.bind(this)
  }

  toggleExpand() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  closeMenu() {
    this.setState({ isExpanded: false })
  }

  render() {
    const { isExpanded } = this.state

    return (
      <header className="mobile-nav-header">
        <button
          type="button"
          aria-label="toggle menu"
          className={`mobile-nav-icon ${isExpanded && 'open'}`}
          onClick={this._toggleExpand}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`mobile-nav-overlay overlay-slidedown ${isExpanded && 'open'}`}>
          <div className="mobile-nav" onClick={this._closeMenu}>
            <NavigationMenuMobile />
          </div>
        </div>
      </header>
    )
  }
}

export default MobileNav
